import { Injectable } from '@angular/core';
import { AlertController , NavController} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { DraftKey, ProductFormService } from 'src/app/services/data-services/product-form.service';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  errorHeader = 'alert.error';
  successHeader = 'alert.success';
  okayButton = 'button.ok';

  constructor(
    private alertController: AlertController,
    private navCtrl: NavController,
    private translate: TranslateService

  ) { }

  async presentAlert(header: string, message: string, buttons: any[]) {
    const alert = await this.alertController.create({
      header,
      message,
      buttons,
      backdropDismiss: false,
      cssClass: 'alert-box'
    });

    await alert.present();
  }

  async presentAlertCss(header: string, message: string, secondMessage: string,buttons: any[], customCss: string) {
    const alert = await this.alertController.create({
      header,
      message:`${message} <br><br> <i>${secondMessage}</i>`,
      buttons,
      backdropDismiss: false,
      cssClass: customCss ? customCss : 'alert-box'
    });

    await alert.present();
  }

  async updateAppAlert(message: string, secondMessage: string, customCss: string) {
    const alert = await this.alertController.create({
      message:`${message} <br><br> <i>${secondMessage}</i>`,
      backdropDismiss: false,
      cssClass: customCss ? customCss : 'alert-box'
    });

    await alert.present();
  }

  async autoDebitPromptCss(header: string, message: string, secondMessage: string, thirdMessage: string, buttons: any[], customCss: string) {
    const alert = await this.alertController.create({
      header,
      message:`${message} <br><br> <i>${secondMessage}</i> <br><br> <i class="thirdMessage">${thirdMessage}</i>`,
      buttons,
      backdropDismiss: false,
      cssClass: customCss ? customCss : 'alert-box'
    });
    await alert.present();
  }

  async successDSR(subHeader: string, message: string,secondMessage: string, buttons?: any[]) {
    const alert = await this.alertController.create({
      subHeader,
      message: `${message} <br><br> <i style="color: red;">${secondMessage}</i>`,
      cssClass: 'dsr-box',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'cancel-button',
          handler: () => {
          this.navCtrl.navigateForward("home");
          console.log('Cancel button clicked');
          }
        },
        {
          text:'Proceed',
          cssClass: 'proceed-button',
          handler: () => {
            this.navCtrl.navigateForward("terms");
            console.log('Proceed clicked');
          }
        }
      ],
      backdropDismiss: false
    });
    await alert.present();
  }

  async presentErrorAlert(message: string, buttons?: any[]) {
    this.presentAlert(this.translate.instant(this.errorHeader), message, buttons || [this.translate.instant(this.okayButton)]);
  }

  async presentSuccessAlert(message: string, buttons?: any[]) {
    this.presentAlert(this.translate.instant(this.successHeader), message, buttons || [this.translate.instant(this.okayButton)]);
  }

  async failDSR(subHeader : string, message : string ,secondMessage,buttons?: any[]) {
    const alert = await this.alertController.create({
      subHeader,
      message: `${message} <br><br> ${secondMessage}`,
      cssClass: 'dsr-box',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'cancel-button',
          handler: () => {
          this.navCtrl.navigateForward("home");
          console.log('Cancel button clicked');
          }
        }
      ],
      backdropDismiss: false
    });
    await alert.present();
  }

  async presentNotifyAlert(
    header: string,
    message: string,
    button: string,
    cancelButtonNeeded: boolean = false,
    laterButtonNeeded: boolean = false) {
    // notify Alert will return boolean as a promise
    let resolveFunction: (confirm: boolean) => void;
    const promise = new Promise<boolean>(resolve => {
      resolveFunction = resolve;
    });

    const buttonsList: Array<any> = [];
    if (cancelButtonNeeded) {
      buttonsList.push({
        text: 'Cancel',
        role: 'cancel',
        handler: () => { }
      });
    }
    // For app version update checking
    if (laterButtonNeeded) {
      buttonsList.push({
        text: 'Later',
        role: 'cancel',
        handler: () => { }
      });
    }
    buttonsList.push({
      text: button,
      handler: () => {
        resolveFunction(true);
      }
    });

    const alert = await this.alertController.create({
      header,
      message,
      buttons: buttonsList,
      backdropDismiss: false,
      // Can style if needed
      cssClass: 'alertPopup'
    });

    await alert.present();
    return promise;

  }

  async usingEmulatorAlert(message: string, customCss: string) {
    const alert = await this.alertController.create({
      message:`${message}`,
      backdropDismiss: false,
      cssClass: customCss ? customCss : 'emulator-alert-box'
    });

    await alert.present();
  }
}
  